<template>
<div class="breadcrumbs">
  <div class="breadcrumbs__container">
    <ul class="breadcrumbs__links">
      <li class="breadcrumbs__linkItem">
        <a href="/" class="breadcrumbs__linkText">グルメプラスTOP</a>
      </li>
      <template v-if="station">
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}</span>
          </li>
        </template>
      </template>
      <template v-else-if="areaDetail">
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}</span>
          </li>
        </template>
      </template>
      <template v-else-if="area">
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
        <li class="breadcrumbs__linkItem">
          <a href="..">
            <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
          </a>
        </li>
        <li class="breadcrumbs__linkItem">
          <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}</span>
        </li>
      </template>
      </template>
      <template v-else>
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}</span>
          </li>
        </template>
      </template>
    </ul>
  </div>
</div>
</template>

<script>
export default {
    props: {
        prefecture: {
            type: String,
            required: true
        },
        area: {
            type: String,
            required: false
        },
        areaDetail: {
            type: String,
            required: false
        },
        station: {
            type: String,
            required: false
        },
        pageType: {
            type: String,
            required: false
        },
        shopType: {
            type: String,
            required: false
        },
        yenOrPeople: {
            type: String,
            required: false
        },
        count: {
            type: Number,
            required: false
        },
        peopleCount: {
            type: Number,
            required: false
        },
        yenCount: {
            type: Number,
            required: false
        }
    },
    computed: {
        typeLabel: function() {
            const pageTypeLabel = {
                'enkai': '忘年会・新年会',
                'konshinkai': '懇親会・パーティー',
                'kansoukai': '歓迎会・送別会',
                'party': '企業パーティー',
                'shaonkai': '謝恩会',
                'dousoukai': '同窓会',
                'nijikai': '二次会',
                'wedding_nijikai': '結婚式二次会',
            }
            const shopTypeLabel = {
                'izakaya': '居酒屋',
                'restaurant_cafe': 'レストラン/カフェ',
                'hotel_banquet': 'ホテル/宴会場',
                'party_space': 'パーティースペース',
                'wedding': '結婚式場（ウェディング）',
                'guesthouse_ceremony': 'ゲストハウス・式場',
                'club': 'クラブ',
                'meeting_room': '会議室',
                'sonota': 'その他会場'
            }
            if (this.pageType) {
                return pageTypeLabel[this.pageType] || '';
            } else if (this.shopType) {
                return shopTypeLabel[this.shopType] || '';
            } else {
                return '';
            }
        },
        yenOrPeopleLabel: function() {
            if (this.yenOrPeople === 'yen') {
                return `予算${this.count}円以下`;
            } else if(this.yenOrPeople === 'people') {
                return `${this.count}人以上`;
            }
        }
    }
}
</script>
